"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("@ikea-aoa/enums");
var exceptions_1 = require("@ikea-aoa/exceptions");
var utilities_1 = require("@ikea-aoa/utilities");
var IowsShoppingBagService_1 = __importDefault(require("../../services/shopping/iows/IowsShoppingBagService"));
var IngkaCartService_1 = __importDefault(require("../../services/shopping/ingka/cart/IngkaCartService"));
var ChinaCartService_1 = __importDefault(require("../../services/shopping/china/cart/ChinaCartService"));
var NifCartService_1 = __importDefault(require("../../services/shopping/nif/NifCartService"));
var RoigPlatformCommunication_1 = __importDefault(require("../../utilities/platform-communication/RoigPlatformCommunication"));
var IrwPlatformCommunication_1 = __importDefault(require("../../utilities/platform-communication/IrwPlatformCommunication"));
var LocalizationService_1 = __importDefault(require("../localization/LocalizationService"));
var AuthenticationQueue_1 = __importDefault(require("./AuthenticationQueue"));
/**
 * This class is used as a simple interface for shopping services.
 */
var ShoppingCartService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    function ShoppingCartService(options) {
        this.consumer = null;
        this.contract = null;
        this.applicationName = null;
        this.localizationPrefixApplication = null;
        this.localizationEndpoints = null;
        this.localizationOverrides = null;
        this.locale = null;
        this.cache = null;
        this.consumer = options.consumer;
        this.contract = options.contract;
        this.applicationName = options.applicationName;
        this.localizationPrefixApplication = options.localizationPrefixApplication;
        this.localizationEndpoints = options.localizationEndpoints;
        this.localizationOverrides = options.localizationOverrides;
        this.locale = options.locale;
        this.cache = options.cache || new utilities_1.GlobalCacheStore();
    }
    /**
     * Adds items to shopping cart.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param [options.vpcForRoig] VPC code used for ROIG.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.addToCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var localizationService, localizedInformation, eCommerceCartDataSource, apiPlatform, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        localizationService = new LocalizationService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            localizationOverrides: this.localizationOverrides,
                            locale: this.locale,
                            cache: this.cache
                        });
                        return [4 /*yield*/, localizationService.getLocalizedInformation()];
                    case 1:
                        localizedInformation = _c.sent();
                        eCommerceCartDataSource = localizedInformation.localization.eCommerceCartDataSource;
                        apiPlatform = localizedInformation.localization.apiPlatform;
                        _a = eCommerceCartDataSource;
                        switch (_a) {
                            case enums_1.EcommerceCartDataSourceEnum.cartApi: return [3 /*break*/, 2];
                            case enums_1.EcommerceCartDataSourceEnum.chinaCartApi: return [3 /*break*/, 4];
                            case enums_1.EcommerceCartDataSourceEnum.iows: return [3 /*break*/, 6];
                            case enums_1.EcommerceCartDataSourceEnum.roig: return [3 /*break*/, 8];
                            case enums_1.EcommerceCartDataSourceEnum.nifApi: return [3 /*break*/, 10];
                            case enums_1.EcommerceCartDataSourceEnum.default: return [3 /*break*/, 12];
                        }
                        return [3 /*break*/, 18];
                    case 2: return [4 /*yield*/, this.addToCartOneWeb({
                            items: options.items,
                            localizedInformation: localizedInformation
                        })];
                    case 3: return [2 /*return*/, _c.sent()];
                    case 4: return [4 /*yield*/, this.addToCartChina({
                            items: options.items,
                            localizedInformation: localizedInformation
                        })];
                    case 5: return [2 /*return*/, _c.sent()];
                    case 6: return [4 /*yield*/, this.addToCartIows({
                            items: options.items,
                            localizedInformation: localizedInformation
                        })];
                    case 7: return [2 /*return*/, _c.sent()];
                    case 8: return [4 /*yield*/, this.addToCartRoig(options.items, options.vpcForRoig)];
                    case 9: return [2 /*return*/, _c.sent()];
                    case 10: return [4 /*yield*/, this.addToCartNif({
                            items: options.items,
                            localizedInformation: localizedInformation
                        })];
                    case 11: return [2 /*return*/, _c.sent()];
                    case 12:
                        _b = apiPlatform;
                        switch (_b) {
                            case enums_1.ApiPlatformEnum.irw: return [3 /*break*/, 13];
                            case enums_1.ApiPlatformEnum.roig: return [3 /*break*/, 15];
                        }
                        return [3 /*break*/, 17];
                    case 13: return [4 /*yield*/, this.addToCartIows({
                            items: options.items,
                            localizedInformation: localizedInformation
                        })];
                    case 14: return [2 /*return*/, _c.sent()];
                    case 15: return [4 /*yield*/, this.addToCartRoig(options.items, options.vpcForRoig)];
                    case 16: return [2 /*return*/, _c.sent()];
                    case 17: throw new exceptions_1.ServiceException("Failed to add items to cart. Unknown api platform \"" + apiPlatform + "\".");
                    case 18: throw new exceptions_1.ServiceException("Failed to add items to cart. Unknown cart data source \"" + eCommerceCartDataSource + "\".");
                }
            });
        });
    };
    /**
     * Returns total amount of items in a shopping cart.
     *
     * @returns Promise object.
     */
    ShoppingCartService.prototype.getCartCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localizationService, localizedInformation, eCommerceCartDataSource, apiPlatform, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        localizationService = new LocalizationService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            localizationOverrides: this.localizationOverrides,
                            locale: this.locale,
                            cache: this.cache
                        });
                        return [4 /*yield*/, localizationService.getLocalizedInformation()];
                    case 1:
                        localizedInformation = _c.sent();
                        eCommerceCartDataSource = localizedInformation.localization.eCommerceCartDataSource;
                        apiPlatform = localizedInformation.localization.apiPlatform;
                        _a = eCommerceCartDataSource;
                        switch (_a) {
                            case enums_1.EcommerceCartDataSourceEnum.cartApi: return [3 /*break*/, 2];
                            case enums_1.EcommerceCartDataSourceEnum.chinaCartApi: return [3 /*break*/, 4];
                            case enums_1.EcommerceCartDataSourceEnum.iows: return [3 /*break*/, 6];
                            case enums_1.EcommerceCartDataSourceEnum.nifApi: return [3 /*break*/, 8];
                            case enums_1.EcommerceCartDataSourceEnum.default: return [3 /*break*/, 10];
                        }
                        return [3 /*break*/, 14];
                    case 2: return [4 /*yield*/, this.getCartCountOneWeb({
                            localizedInformation: localizedInformation
                        })];
                    case 3: return [2 /*return*/, _c.sent()];
                    case 4: return [4 /*yield*/, this.getCartCountChina({
                            localizedInformation: localizedInformation
                        })];
                    case 5: return [2 /*return*/, _c.sent()];
                    case 6: return [4 /*yield*/, this.getCartCountIows({
                            localizedInformation: localizedInformation
                        })];
                    case 7: return [2 /*return*/, _c.sent()];
                    case 8: return [4 /*yield*/, this.getCartCountNif({
                            localizedInformation: localizedInformation
                        })];
                    case 9: return [2 /*return*/, _c.sent()];
                    case 10:
                        _b = apiPlatform;
                        switch (_b) {
                            case enums_1.ApiPlatformEnum.irw: return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 13];
                    case 11: return [4 /*yield*/, this.getCartCountIows({
                            localizedInformation: localizedInformation
                        })];
                    case 12: return [2 /*return*/, _c.sent()];
                    case 13: throw new exceptions_1.ServiceException("Failed to get cart count. Unknown api platform \"" + apiPlatform + "\".");
                    case 14: throw new exceptions_1.ServiceException("Failed to get cart count. Unknown cart data source \"" + eCommerceCartDataSource + "\".");
                }
            });
        });
    };
    /**
     * Adds items to shopping cart.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.addToCartIows = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue, user, cart, platform;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new IowsShoppingBagService_1.default({
                            consumer: this.consumer,
                            contract: this.contract,
                            endpoint: options.localizedInformation.endpoints.iowsShoppingBagService
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.getAuthenticationIows({
                                consumer: this.consumer,
                                contract: this.contract,
                                endpoint: options.localizedInformation.endpoints.iowsAuthenticationServiceV2
                            })];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, shoppingService.addToCart({
                                items: options.items,
                                userId: user.id
                            })];
                    case 2:
                        cart = _a.sent();
                        platform = new IrwPlatformCommunication_1.default({ applicationName: this.applicationName });
                        platform.setCartCount(cart.cartCount);
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    /**
     * Returns cart count for IOWS.
     *
     * @param options Options.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.getCartCountIows = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new IowsShoppingBagService_1.default({
                            consumer: this.consumer,
                            contract: this.contract,
                            endpoint: options.localizedInformation.endpoints.iowsShoppingBagService
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.getAuthenticationIows({
                                consumer: this.consumer,
                                contract: this.contract,
                                endpoint: options.localizedInformation.endpoints.iowsAuthenticationServiceV2
                            })];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, shoppingService.getCartCount({
                                userId: user.id
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds items to shopping cart.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.addToCartOneWeb = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue, token, cart, platform;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new IngkaCartService_1.default({
                            locale: this.locale,
                            endpoint: options.localizedInformation.endpoints.ingkaCartService,
                            clientId: options.localizedInformation.localization.ingkaApiClientId,
                            clientSecret: options.localizedInformation.localization.ingkaApiClientSecret
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.getAuthTokenOneWeb({
                                endpoint: options.localizedInformation.endpoints.oneWebAuthenticationToken
                            })];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, shoppingService.addToCart({
                                items: options.items,
                                token: token
                            })];
                    case 2:
                        cart = _a.sent();
                        platform = new IrwPlatformCommunication_1.default({ applicationName: this.applicationName });
                        platform.setCartCount(cart.cartCount);
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    /**
     * Returns cart count for one web.
     *
     * @param options Options.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.getCartCountOneWeb = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new IngkaCartService_1.default({
                            locale: this.locale,
                            endpoint: options.localizedInformation.endpoints.ingkaCartService,
                            clientId: options.localizedInformation.localization.ingkaApiClientId,
                            clientSecret: options.localizedInformation.localization.ingkaApiClientSecret
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.getAuthTokenOneWeb({
                                endpoint: options.localizedInformation.endpoints.oneWebAuthenticationToken
                            })];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, shoppingService.getCartCount({
                                token: token
                            })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds items to shopping cart.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.addToCartChina = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue, token, error_1, token_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new ChinaCartService_1.default({
                            endpoint: options.localizedInformation.endpoints.chinaCartService
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.getAuthTokenChina({
                                refreshTokenEndpoint: options.localizedInformation.endpoints.chinaAuthenticationRefreshToken,
                                loginPageEndpoint: options.localizedInformation.endpoints.chinaAuthenticationLoginPage
                            })];
                    case 1:
                        token = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 8]);
                        return [4 /*yield*/, shoppingService.addToCart({
                                items: options.items,
                                token: token
                            })];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_1 = _a.sent();
                        if (!(error_1.exceptionType === exceptions_1.ExceptionTypeEnum.serverErrorResponse &&
                            error_1.serverResponse.status === 401)) return [3 /*break*/, 7];
                        return [4 /*yield*/, authQueue.getAuthTokenChina({
                                refreshTokenEndpoint: options.localizedInformation.endpoints.chinaAuthenticationRefreshToken,
                                loginPageEndpoint: options.localizedInformation.endpoints.chinaAuthenticationLoginPage,
                                login: true
                            })];
                    case 5:
                        token_1 = _a.sent();
                        return [4 /*yield*/, shoppingService.addToCart({
                                items: options.items,
                                token: token_1
                            })];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7: throw error_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns cart count for china.
     *
     * @param options Options.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.getCartCountChina = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue, token, error_2, token_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new ChinaCartService_1.default({
                            endpoint: options.localizedInformation.endpoints.chinaCartService
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.getAuthTokenChina({
                                refreshTokenEndpoint: options.localizedInformation.endpoints.chinaAuthenticationRefreshToken,
                                loginPageEndpoint: options.localizedInformation.endpoints.chinaAuthenticationLoginPage
                            })];
                    case 1:
                        token = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 8]);
                        return [4 /*yield*/, shoppingService.getCartCount({
                                token: token
                            })];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_2 = _a.sent();
                        if (!(error_2.exceptionType === exceptions_1.ExceptionTypeEnum.serverErrorResponse &&
                            error_2.serverResponse.status === 401)) return [3 /*break*/, 7];
                        return [4 /*yield*/, authQueue.getAuthTokenChina({
                                refreshTokenEndpoint: options.localizedInformation.endpoints.chinaAuthenticationRefreshToken,
                                loginPageEndpoint: options.localizedInformation.endpoints.chinaAuthenticationLoginPage,
                                login: true
                            })];
                    case 5:
                        token_2 = _a.sent();
                        return [4 /*yield*/, shoppingService.getCartCount({
                                token: token_2
                            })];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7: throw error_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds items to shopping cart.
     *
     * @param items Array of shopping items.
     * @param [vpcCode] VPC Code.
     * @returns Cart.
     */
    ShoppingCartService.prototype.addToCartRoig = function (items, vpcCode) {
        var platform = new RoigPlatformCommunication_1.default();
        platform.addToCart(items, vpcCode);
        return {
            cartCount: null,
            errorList: []
        };
    };
    /**
     * Adds items to shopping cart.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.addToCartNif = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, platform, authQueue, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new NifCartService_1.default({
                            endpoint: options.localizedInformation.endpoints.nifECommerceApiEndpoint,
                            locale: this.locale
                        });
                        platform = new RoigPlatformCommunication_1.default();
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.authenticateNif({
                                endpoint: options.localizedInformation.endpoints.nifECommerceApiEndpoint
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, shoppingService.addToCart({
                                items: options.items
                            })];
                    case 2:
                        cart = _a.sent();
                        platform.setCartCount(cart.cartCount);
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    /**
     * Returns cart count for NIF.
     *
     * @param options Options.
     * @param options.localizedInformation Localized information.
     * @returns Promise object.
     */
    ShoppingCartService.prototype.getCartCountNif = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var shoppingService, authQueue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shoppingService = new NifCartService_1.default({
                            endpoint: options.localizedInformation.endpoints.nifECommerceApiEndpoint,
                            locale: this.locale
                        });
                        authQueue = new AuthenticationQueue_1.default(this.cache);
                        return [4 /*yield*/, authQueue.authenticateNif({
                                endpoint: options.localizedInformation.endpoints.nifECommerceApiEndpoint
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, shoppingService.getCartCount()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ShoppingCartService;
}());
exports.default = ShoppingCartService;
//# sourceMappingURL=ShoppingCartService.js.map